import Buttons from '@ui/elements/Buttons'
import Div from '@ui/layout/Div'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import Modal from '@ui/component/Modal'
import CitizenSterilizationCallMaker from '@scene/window/sterilization/CitizenSterilizationCallMaker'
import CompanySterilizationCallMaker from '@scene/window/sterilization/CompanySterilizationCallMaker'
import useDownloadFile from '@hook/useDownloadFile'
import useDynamicForm from '@hook/useDynamicForm'
import DropDown from '@ui/component/DropDown'

const SterilizationListCommands = () => {
  const [t] = useTranslation('common')
  const [formType, setFormType] = useState(false)
  const toggleDynamicForm = useDynamicForm()
  const { mission } = useSelector(state => state.main)
  const { mairie, missionTitle, isCompany } = mission

  const downLoadFile = useDownloadFile()
  const missionFullTitle = t('labels.header_intro', { missionTitle, targetMairie: mairie.name, year: new Date().getFullYear() })

  const exportCalls = (format, scan = 'global') => {
    let query = `mission=${mission.id}&scan=${scan}`
    const extension = "csv" === format ? "csv" : "pdf"
    const fileName = `
    ${missionFullTitle}-${'firstScan' === scan
        ? t('labels.first_scan')
        : ('secondScan' === scan ? t('labels.second_scan') : t('labels.full_scan'))
      }`
    downLoadFile(`${import.meta.env.VITE_API_URL}/api/missions/${mission.id}/calls/export/${format}?${query}`, fileName, extension)
  }

  const getDynamicForm = () => {
    switch (formType) {
      case 'citizenCall':
        return <CitizenSterilizationCallMaker />
      case 'companyCall':
        return <CompanySterilizationCallMaker />
    }
  }

  const dropConfig = {
    title: t('actions.export_csv_calls'),
    menu: [
      {
        title: t('actions.export_csv_calls_first_scan'),
        text: t('actions.export_csv_calls_first_scan'),
        link: '#',
        otherProps: { onClick: () => exportCalls('csv', 'firstScan') }
      },
      {
        title: t('actions.export_csv_calls_second_scan'),
        text: t('actions.export_csv_calls_second_scan'),
        link: '#',
        otherProps: { onClick: () => exportCalls('csv', 'secondScan') }
      },
      {
        title: t('actions.export_csv_calls_global'),
        text: t('actions.export_csv_calls_global'),
        link: '#',
        otherProps: { onClick: () => exportCalls('csv', 'global') }
      },
    ]
  }

  return (
    <>
      <Div cssClass='actions-zone'>
        <DropDown dropConfig={dropConfig} cssClass='csv-exporter' mainButtonCssClass='is-small' />
        <Buttons buttons={[
          {
            icon: 'icon-clipboard',
            cssClass: 'is-link is-inverted is-small',
            callback: () => exportCalls('pdf'),
            text: t('actions.export_pdf_calls')
          },
          {
            icon: 'icon-add',
            cssClass: 'is-info is-small',
            callback: () => setFormType('citizenCall'),
            text: t('actions.add_citizen_call')
          }, {
            icon: 'icon-add',
            cssClass: `is-info is-small ${!isCompany ? 'is-hidden' : ''}`,
            callback: () => setFormType('companyCall'),
            text: t('actions.add_company_call')
          }, {
            icon: 'icon-upload',
            cssClass: 'is-warning is-small',
            callback: () => toggleDynamicForm('loadCalls'),
            text: t('actions.load_calls')
          }
        ]} />
      </Div>
      <Modal cssClass='call-form-modal' isActive={formType} closeCallback={() => setFormType(false)} closeAction={true}>
        {getDynamicForm()}
      </Modal>
    </>
  )
}

export default SterilizationListCommands